import React from "react";

export const Section = ({
    children,
    className = "",
    id,
    ...props
}) => {
    return (
        <section
            id={id}
            className={`relative py-24 lg:py-32 ${className}`}
            {...props}
        >
            {children}
        </section>
    );
};

export default Section;
